import React from "react";
import Dashboard from "../../components/Dashboard/Dashboard";
import ItemWrapper from "./ItemWrapper";
import { CryptoItems } from "./CryptoItems";
import useFetch from "../../hooks/useFetch"

const Trade = (props) => {
  const {response:rates} = useFetch()
  return (
    <Dashboard {...props} back={() => props.history.push("/dashboard")}>
      <div className="item-wrapper justify-content-center mb-5">
        {CryptoItems.map((item) => (
          <ItemWrapper
            id={item.id}
            src={item.src}
            name={item.name}
            brate={rates.length >0 ? rates.filter(el=>el.Crypto === item.short)[0].Buy:""}
            srate={rates.length >0 ? rates.filter(el=>el.Crypto === item.short)[0].Sell:""}
            key={item.id}
            img={item.img}
            available={item.srate === "Coming soon" ? "true" : "false"}
          />
        ))}
      </div>
    </Dashboard>
  );
};

export default Trade;
